import { createSlice, Slice } from '@reduxjs/toolkit'

import { CompanyData } from 'modules/accountActivity/domain'

export interface CompanyDataState extends Partial<CompanyData> {
  loaded: boolean
  isFetching: boolean
}

const initialState: CompanyDataState = {
  loaded: false,
  isFetching: false
}

export const companyDataSlice: Slice<CompanyDataState> = createSlice({
  name: 'companyData',
  initialState,
  reducers: {
    loadCompanyData: (state, { payload }) => ({
      ...state,
      ...payload,
      loaded: true,
      isFetching: false
    })
  }
})

const { reducer: CompanyDataReducer, actions } = companyDataSlice

export const { loadCompanyData } = actions

export default CompanyDataReducer
